<script setup>
import { defineProps, defineEmits, onMounted, onBeforeUnmount, nextTick } from 'vue';

defineProps({
    subtabs: {
        type: Array,
        required: true,
    },
    activeSubTab: {
        type: String,
        required: true
    }
});

const emit = defineEmits(['update:activeSubTab']);

const updateSubTabIndicator = () => {
    const activeSubTabElement = document.querySelector('.subtabs__btn--active')
    if (activeSubTabElement) {
        const subTabsContainer = document.querySelector('.subtabs')
        const subTabLeft = activeSubTabElement.offsetLeft
        const subTabWidth = activeSubTabElement.offsetWidth

        subTabsContainer.style.setProperty('--tab-width', `${subTabWidth}px`)
        subTabsContainer.style.setProperty('--tab-left', `${subTabLeft}px`)
    }
}

const handleSubTabChange = (subTabId) => {
    emit('update:activeSubTab', subTabId);
    nextTick(() => {
        updateSubTabIndicator();
    });
};

onMounted(() => {
    updateSubTabIndicator()
    window.addEventListener('resize', updateSubTabIndicator)
})

onBeforeUnmount(() => {
    window.removeEventListener('resize', updateSubTabIndicator)
})
</script>

<template>
    <nav class="subtabs">
        <button 
            v-for="tab in subtabs" 
            :key="tab.id" 
            class="subtabs__btn"
            :class="{ 'subtabs__btn--active': tab.id === activeSubTab }" 
            @click="handleSubTabChange(tab.id)"
        >
            {{ tab.label }}
        </button>
    </nav>
</template>

<style scoped lang="postcss">
.subtabs {
    @apply relative flex gap-1 p-1
    text-white/80 hover:text-white
    bg-echoes-background-black rounded-[13px] border border-echoes-border-gray;
}

.subtabs__btn {
    @apply px-4 py-2 text-xs sm:text-sm rounded-lg w-full sm:w-fit
            font-medium 
           transition-all duration-300 ease-in-out relative z-10 min-w-[80px]
           hover:bg-echoes-background-gray/50;
    
    &::after {
        content: '';
        @apply absolute inset-0 rounded-lg
               border border-transparent
               transition-all duration-300 ease-in-out;
    }

}

.subtabs__btn--active {
    @apply 
        
         font-medium text-echoes-primary bg-echoes-background-gray hover:bg-echoes-background-gray/50 ;
    
    &::before {
        content: '';
        @apply absolute inset-0 rounded-md
           
            
    }

    &::after {
        @apply  ring-echoes-border-gray;
    }


}


@keyframes fadeIn {
    from {
        opacity: 0.7;
        transform: translateY(2px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}
</style>